import {
  Callout,
  Disclaimer,
  Div,
  lightTheme,
  P,
  TooltipWrapper,
  VDriveStrategySuggestion,
} from '@vgrubs/components';
import { baselineFigures } from '../helpers/strategySuggestionFormat';
import {
  DataPill,
  Figure,
  FigureGrid,
  FigureValue,
} from '../StrategySuggestion.styled';

type Props = {
  result: VDriveStrategySuggestion;
};

/** The top of the suggestion: what the data was, how it goes now, the gist. */
export const SuggestionOverview = ({ result }: Props) => {
  const { data } = result;
  const nearbyNames = data.nearbyLocations
    .map((location) => `${location.name} (${location.miles} mi)`)
    .join(', ');

  return (
    <Div $flex $column $gap="16px">
      {(data.lowVolume ||
        data.nearbyLocations.length > 0 ||
        data.includesLocationDeliveries) && (
        <Div $flex $gap="6px" $wrap>
          {data.lowVolume && (
            <DataPill>Little data ({data.completed} deliveries)</DataPill>
          )}
          {data.includesLocationDeliveries && (
            <DataPill>Includes the whole location</DataPill>
          )}
          {data.nearbyLocations.length > 0 && (
            <TooltipWrapper tooltip={nearbyNames}>
              <DataPill>
                + {data.nearbyLocations.length} nearby{' '}
                {data.nearbyLocations.length === 1 ? 'location' : 'locations'}
              </DataPill>
            </TooltipWrapper>
          )}
        </Div>
      )}

      {result.inheritedFromLocation && (
        <Callout tone="info">
          <P $m="0">
            This brand uses the location strategy; applying creates the
            brand&apos;s own strategy.
          </P>
        </Callout>
      )}

      <P $m="0">{result.summary}</P>

      <FigureGrid>
        {baselineFigures(result).map((figure) => (
          <Figure key={figure.label}>
            <Disclaimer $m="0" $color={lightTheme.lightGray}>
              {figure.label}
            </Disclaimer>
            <FigureValue>{figure.value}</FigureValue>
            {figure.hint && (
              <Disclaimer $m="0" $color={lightTheme.lightGray}>
                {figure.hint}
              </Disclaimer>
            )}
          </Figure>
        ))}
      </FigureGrid>
    </Div>
  );
};
